<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../assets/header.png"
      />
      <img class="img20-1" src="../assets/header20.jpg" alt="" />
      <div class="liang">
        <span class="text_99">2023年05月09日 11 : 32 : 23</span>
        <span class="text_99">乌山九巷B1停车场</span>
      </div>

      <div class="text-wrapper_01 flex-row justify-between">
        <span class="text_01">{{ y1 }}</span>
        <span class="text_01">{{ y2 }}</span>
      </div>

      <div class="group_2 flex-col">
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          src="../assets/ditu20.png"
        />

        <div class="block_2 flex-row justify-end">
          <span class="text_6">查找车位</span>
          <div class="image-wrapper_2 flex-col">
            <img
              class="thumbnail_1"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps9pa8qdtx0wjvytzv50j3xq59cw3blpih37206b4f0-b47b-4216-8011-95f14fa60f57"
            />
          </div>
        </div>

        <div class="image-text_1 flex-row justify-between">
          <div class="image-wrapper_3 flex-col align-center">
            <img
              class="thumbnail_2"
              referrerpolicy="no-referrer"
              src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps1iynejzxvmniomj7zo3sb1ahtogoznfrib4c6603e-650b-43e7-aa56-ad6ff5a2611f"
            />
          </div>
          <span class="text-group_1">A2-546车位信息查看</span>
        </div>

        <div class="group_4 flex-col">
          <div class="text-wrapper_3 flex-row">
            <span class="text_7">A2-546基本信息</span>
          </div>
          <div class="box_4 flex-row">
            <div class="box_5 flex-col"></div>
            <span class="text_8">车位属性</span>
            <span class="text_9">业主车位</span>
          </div>
          <div class="box_6 flex-row">
            <div class="group_5 flex-col"></div>
            <span class="text_10">使用情况</span>
            <span class="text_11">&nbsp;短租中</span>
          </div>
          <div class="box_7 flex-row">
            <div class="section_6 flex-col"></div>
            <span class="text_12">收益率</span> <span class="text_13">72%</span>
          </div>
          <div class="box_8 flex-row">
            <div class="box_9 flex-col"></div>
            <span class="text_14">使用率</span> <span class="text_15">72%</span>
          </div>
          <div class="box_10 flex-col"></div>
          <div class="box_11 flex-col"></div>
          <div class="box_12 flex-col"></div>
          <div class="box_13 flex-col"></div>
        </div>

        <div class="section_4 flex-col">
          <div class="block_3 flex-col"></div>
        </div>

        <div class="group_11 flex-col">
          <div class="group_12 flex-row justify-between">
            <div class="section_9 flex-col"></div>
            <div class="text-group_2 flex-col justify-between">
              <span class="text_21">2023-05-09&nbsp;11:30</span>
              <span class="text_22">短租车停放</span>
              <span class="text_22">苏AB3159</span>
            </div>
          </div>
          <div class="image-wrapper_9 flex-row">
            <img
              class="image_10"
              referrerpolicy="no-referrer"
              src="../assets/jia1.jpg"
            />
          </div>
          <div class="group_13 flex-col"></div>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  width: 100%;

  overflow: hidden;
}
.liang {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin-left: 5%;
}
.text_99 {
  color: #ffffff;
}
.group_11 {
  height: 220px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pso9hs0s08uch08s78dppgkshvyfvhr6jhggf5a5e084-2461-471f-9b4c-9e37a448a853)
    0px 0px no-repeat;
  background-size: 230px 180px;
  width: 229px;
  position: absolute;
  left: 885px;
  top: 820px;
  border: 2px solid #1d317a;
}

.group_112 {
  height: 220px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pso9hs0s08uch08s78dppgkshvyfvhr6jhggf5a5e084-2461-471f-9b4c-9e37a448a853)
    0px 0px no-repeat;
  background-size: 230px 180px;
  width: 229px;
  position: absolute;
  left: 885px;
  top: 820px;
  border: 2px solid #1d317a;
}

.group_113 {
  height: 220px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pso9hs0s08uch08s78dppgkshvyfvhr6jhggf5a5e084-2461-471f-9b4c-9e37a448a853)
    0px 0px no-repeat;
  background-size: 230px 180px;
  width: 229px;
  position: absolute;
  left: 1285px;
  top: 820px;
  border: 2px solid #1d317a;
}

.group_12 {
  width: 168px;
  height: 46px;
  margin: 20px 0 0 34px;
}

.section_9 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 5px;
}

.text-group_2 {
  width: 145px;
  height: 46px;
}

.text_21 {
  width: 145px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_22 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 10px;
}

.image-wrapper_9 {
  width: 112px;
  height: 89px;
  margin: 33px 0 12px 57px;
}

.image_10 {
  width: 112px;
  height: 89px;
}

.group_13 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 21px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}
.section_4 {
  background-color: rgba(0, 255, 246, 0.3);
  border-radius: 4px;
  height: 10px;
  border: 1px solid rgba(0, 255, 246, 1);
  width: 1203px;
  margin-left: 450px;
  margin-top: 80px;
}

.block_3 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 5px;
  width: 584px;
  height: 10px;
  margin-left: -9px;
}
.group_4 {
  height: 224px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psuzs6s0r49u840hex8hj9zjdpeku5ti6o6fb46737a-dccb-4934-9f57-fd5433697278)
    100% no-repeat;
  background-size: 100% 100%;
  width: 290px;
  position: absolute;
  left: 47px;
  top: 750px;
  justify-content: flex-center;

  border: 2px solid #1d317a;
}

.text-wrapper_3 {
  width: 143px;
  height: 19px;
  margin: 25px 0 0 29px;
}

.text_7 {
  width: 143px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.box_4 {
  width: 220px;
  height: 20px;
  margin: 22px 0 0 34px;
}

.box_5 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.text_8 {
  width: 78px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 18px;
}

.text_9 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 39px;
}

.box_6 {
  width: 204px;
  height: 20px;
  margin: 18px 0 0 34px;
}

.group_5 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.text_10 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 17px;
}

.text_11 {
  width: 59px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 42px;
}

.box_7 {
  width: 183px;
  height: 20px;
  margin: 17px 0 0 34px;
}

.section_6 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.text_12 {
  width: 58px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 18px;
}

.text_13 {
  width: 42px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 59px;
}

.box_8 {
  width: 183px;
  height: 20px;
  margin: 18px 0 25px 34px;
}

.box_9 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.text_14 {
  width: 59px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 17px;
}

.text_15 {
  width: 42px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 59px;
}

.box_10 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 69px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.box_11 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 107px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.box_12 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 144px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}

.box_13 {
  border-radius: 50%;
  position: absolute;
  left: 30px;
  top: 182px;
  width: 14px;
  height: 14px;
  border: 1px solid rgba(0, 255, 246, 1);
}
.image-text_1 {
  width: 275px;
  height: 26px;
  float: left;
  margin-left: 400px;
  margin-top: -30px;
}

.image-wrapper_3 {
  height: 15px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps1pgrtjox2d2e8yt1b81bdo8niutv4dx55e7e4f195-1168-4cc1-8d3d-c5bf48b392c7)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 5px;
  width: 14px;
}

.thumbnail_2 {
  width: 14px;
  height: 15px;
}

.text-group_1 {
  width: 243px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 26px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}
.block_2 {
  width: 215px;
  height: 35px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psatrsbl4tmcq9qz9x9qcsqo6frils2ynwf4e41906e-ea83-4afb-8cb5-defa2d7a459d)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 580px;
  margin-left: 40px;
}

.text_6 {
  width: 64px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(230, 230, 230, 1);
  font-size: 14px;
  font-family: SourceHanSansSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 14px;
  margin: 11px 0 0 10px;
}

.image-wrapper_2 {
  height: 35px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps9dyi8invv58gppqrigqy0gx8e6klb41w09a8cd6f-0d6d-4508-8d34-e6ff4a5a1d2c) -1px
    0px no-repeat;
  background-size: 45px 35px;
  margin-left: 97px;
  width: 44px;
}

.thumbnail_1 {
  width: 19px;
  height: 17px;
  margin: 9px 0 0 12px;
}
.img20-1 {
  width: 1000px;
  height: 70px;
  margin-left: 450px;
  margin-top: -90px;
}
.olo {
  border: 1px solid #ffffff;
  width: 200px;
  height: 200px;
}
.wancheng {
  margin-left: -184px;
  margin-top: -20px;
}
.dianchi {
  position: relative;
  top: -107px;
  left: 30px;
}
.chartsv3 {
  width: 150px;
  height: 150px;
  /* border: 1px solid red; */
  margin-top: -25px;
  margin-left: -5px;
}

.echarts2 {
  margin-top: -142px;
  margin-left: 13px;
  width: 150px;
  height: 150px;
  /* border: 1px solid red; */
}
.echarts3 {
  /* border: 1px solid red; */
  width: 150px;
  height: 150px;
  position: relative;
  left: 63px;
  top: -97px;
}
.text-wrapper_01 {
  width: 330px;
  height: 19px;
  margin: -30px 0 10px 11px;
  /* border: 1px solid white; */
}
.wanc {
  margin: 205px 0 0 -135px;
}
.wangs {
  color: rgba(0, 255, 246, 1);
  font-size: 12px;
  position: relative;
  top: -158px;
  left: 125px;
}
.dian2 {
  margin-top: -80px;
}
.centerContenttxt3 {
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 400;
  color: #ffffff;
}
.oneline {
  display: flex;
  justify-content: space-around;

  margin-top: 8px;
}
.centerContenttxt2 {
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: bold;
  color: #ffffff;
}
.left2center_col3table {
  //   width: 400px;
  height: 200px;

  margin-top: 20px;

  ::v-deep .header-item {
    font-size: 20px !important;
    font-family: SourceHanSansSC-Bold !important;
    font-weight: bold !important;
    color: rgba(0, 255, 246, 1);
    background-color: #1b569b;
  }
  ::v-deep .row-item {
    color: #6b7cab;
    // color: #90a9c8;
    font-size: 20px !important;
    font-family: SourceHanSansSC-Regular !important;
    font-weight: bold !important;
    // margin-bottom: 12px !important;
  }
}
.bottomContent3txt2tablev3 {
  height: 100px;
  margin-top: -20px;
  position: absolute;
  z-index: 1000;

  ::v-deep .header-item {
    font-size: 18px !important;
    font-family: SourceHanSansSC-Bold !important;
    // font-weight: bold !important;
    color: #ffffff;
  }
  ::v-deep .row-item {
    // height: 30px !important;
    color: #ffffff;
    // color: #90a9c8;
    font-size: 16px !important;
    font-family: SourceHanSansSC-Regular !important;

    // margin-bottom: 12px !important;

    margin-top: -12px !important;
  }
}
.ku1 {
  position: relative;
  top: -190px;
  left: 37px;
  width: 100px;
  height: 60px;
  text-align: center;
}
.ku_c1 {
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: 700;
}
.ku_c2 {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
}
.ku2_c1 {
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: 700;
}
.ku2 {
  width: 100px;
  height: 60px;
  text-align: center;
  margin: -80px 0 0 -180px;
}
.ku2_c2 {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
}

.text_01 {
  width: 146px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}
.text_011 {
  color: rgba(254, 254, 255, 1);
  position: absolute;
}
.text_02 {
  width: 177px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(254, 254, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
}
.group_1 {
  width: 1980px;
  height: 1080px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps14qu5lgw2pl7e6gs1uuj5eu7uy4zkstbof890a1a6-0e90-4243-9adc-4dcdc3cb1a77)
    100% no-repeat;
  background-size: 100% 100%;
}

.image_1 {
  width: 1916px;
  height: 94px;
}

.group_2 {
  width: 1980px;
  height: 987px;
  margin-bottom: 1px;
}

.box_1 {
  position: relative;
  width: 1920px;
  height: 327px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps94kz3bggzj7bay9tdnarq4eusqmhelgad8fed6dfb-d4a6-469c-8fae-898e2676eb03)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 8px 0 0 0px;
}

.group_3 {
  width: 364px;
  height: 240px;
  margin: 46px 0 0 85px;
}

.section_1 {
  width: 209px;
  height: 19px;
  margin-left: 14px;
}

.text_1 {
  width: 78px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 14px;
}

.text_2 {
  width: 83px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 2px 0 0 20px;
}

.text_3 {
  width: 210px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 10px 0 0 139px;
}

.section_2 {
  width: 267px;
  height: 23px;
  margin: 19px 0 0 18px;
}

.box_2 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 6px;
}

.text_4 {
  width: 118px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 16px;
}

.image_2 {
  width: 24px;
  height: 18px;
  margin: 3px 0 0 17px;
}

.label_1 {
  width: 24px;
  height: 23px;
  margin-left: 19px;
}

.image_3 {
  width: 22px;
  height: 20px;
  margin: 3px 0 0 21px;
}

.section_3 {
  width: 346px;
  height: 20px;
  margin: 15px 0 0 18px;
}

.text_5 {
  width: 100px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 15px;
}

.box_3 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 5px;
  height: 10px;
  margin-left: -1px;
  width: 98px;
}

.group_6 {
  box-shadow: 0px 1px 5px 0px rgba(9, 184, 202, 1);
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 14px;
  height: 14px;
  margin: -1px 0 0 91px;
}

.text_06 {
  width: 23px;
  height: 9px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: DIN-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 12px;
  margin: -60px 0 0 -155px;
}

.block_1 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 50%;
  width: 6px;
  height: 6px;
  margin-top: 7px;
}

.text-wrapper_1 {
  height: 49px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psdxn2purxggwcp6u2ks8dexregofmkguo4cba6b37-8bfa-4b01-9ab8-d5b06b66325b)
    100% no-repeat;
  background-size: 100% 100%;
  margin-top: 29px;
  width: 363px;
}

.group_7 {
  width: 178px;
  height: 231px;
  margin: 48px 0 0 9px;
}

.image_4 {
  position: absolute;
  left: 40px;
  top: 120px;
  width: 95%;
  height: 518px;
}

.text-wrapper_2 {
  height: 99px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pswzx3fmh7kotyu2pb558exvmhw6fh5c7d7b7b76-fddf-4b34-920c-63fee297dd9b)
    100% no-repeat;
  background-size: 100% 100%;
  width: 140px;
  margin: -4px 0 0 20px;
}

.image-wrapper_1 {
  width: 177px;
  height: 135px;
  margin: 180px 0 0 10px;
}

.image_5 {
  width: 177px;
  height: 136px;
  position: relative;
  left: 50px;
  top: 50px;
}

.image_6 {
  width: 139px;
  height: 99px;
  margin: 10px 0 0 15px;
}

.image_7 {
  width: 130px;
  height: 215px;
  margin: 64px 0 0 36px;
  /* border: 1px solid white; */
}
.image_07 {
  height: 324px;
  width: 576px;
  /* position: absolute; */
  position: relative;
  left: -220px;
  top: -60px;

  -webkit-backface-visibility: hidden;
  background: transparent;
}
.group_8 {
  background-color: rgba(0, 255, 246, 1);
  border-radius: 3px;
  width: 22px;
  height: 23px;
  margin: 139px 0 0 18px;
}

.group_9 {
  width: 128px;
  height: 243px;
  margin: 29px 0 0 15px;
}

.text-wrapper_4 {
  height: 46px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psqjxjcbwaekij15xdbdedef4yeflcjc28vb9578ee7-ea79-4e55-82c5-66fa2cdc7be6)
    100% no-repeat;
  background-size: 100% 100%;
  width: 128px;
}

.text-wrapper_5 {
  height: 30px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psasu9x8meui7e73mj2ddbjdpxmd0h8ac37e57dc9f7-0efe-4059-a8f5-1ed7994c494d) -4px -4px
    no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_16 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 88px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 22px;
  font-family: Adobe Heiti Std R;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 3px 0 0 7px;
}

.text-wrapper_6 {
  width: 121px;
  height: 121px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psqacbkppi2o226mn9x8o28fdozbid2rg435a2a5d6-3def-4b16-81e4-2abf0d97449d)
    100% no-repeat;
  background-size: 100% 100%;
  margin: 18px 0 0 3px;
}

.text_17 {
  width: 79px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 19px 0 0 21px;
}

.text_18 {
  width: 87px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 13px 0 0 17px;
}

.text_19 {
  width: 75px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 22px 23px;
}

.group_10 {
  width: 514px;
  height: 239px;
  margin: 41px 92px 0 49px;
}

.label_2 {
  margin-top: -15px;
  width: 24px;
  height: 23px;
}

.text_20 {
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(144, 169, 200, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 4px 0 0 12px;
}

.text_23 {
  width: 126px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  margin: 6px 0 0 25px;
}

.text-wrapper_7 {
  width: 511px;
  height: 29px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psep9iif4b5uirr0gyaxr1pls8yegrs2y49bc42e1-e65e-4c8e-a76e-b489e620f253) -1px
    0px no-repeat;
  background-size: 513px 29px;
  margin: 15px 0 0 1px;
}

.text_24 {
  width: 31px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 17px;
}

.text_25 {
  width: 63px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 0 0 44px;
}

.text_26 {
  width: 95px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(0, 255, 246, 1);
  font-size: 16px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 6px 35px 0 226px;
}

.text-wrapper_8 {
  width: 452px;
  height: 19px;
  margin: 16px 0 0 32px;
}

.text_27 {
  width: 9px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.text_28 {
  width: 38px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 53px;
}

.text_29 {
  width: 101px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 251px;
}

.text-wrapper_9 {
  width: 432px;
  height: 20px;
  margin: 15px 0 0 31px;
}

.text_30 {
  width: 10px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_31 {
  width: 79px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_32 {
  width: 80px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 211px;
}

.text-wrapper_10 {
  width: 432px;
  height: 20px;
  margin: 14px 0 0 31px;
}

.text_33 {
  width: 10px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 1px;
}

.text_34 {
  width: 39px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_35 {
  width: 81px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 250px;
}

.text-wrapper_11 {
  width: 432px;
  height: 19px;
  margin: 15px 0 0 31px;
}

.text_36 {
  width: 11px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.text_37 {
  width: 38px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_38 {
  width: 81px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 250px;
}

.text-wrapper_12 {
  width: 483px;
  height: 20px;
  margin: 14px 0 0 31px;
}

.text_39 {
  width: 10px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 3px;
}

.text_40 {
  width: 39px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 52px;
}

.text_41 {
  width: 131px;
  height: 19px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 1px 0 0 251px;
}

.image_8 {
  position: absolute;
  left: 1054px;
  top: 66px;
  width: 38px;
  height: 87px;
}
.image_82 {
  position: absolute;
  left: 1054px;
  top: 152px;
  width: 38px;
  height: 87px;
  display: inline-block;
  -moz-transform: scaleY(-1);
  -webkit-transform: scaleY(-1);
  -o-transform: scaleY(-1);
  transform: scaleY(-1);
}
.image_83 {
  position: absolute;
  left: 1054px;
  top: 115px;
  width: 38px;
  height: 47px;
  -moz-transform: rotate(40deg);
  -webkit-transform: rotate(40deg);
}

.text_42 {
  width: 77px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 15px;
}

.group_14 {
  height: 40px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psasqcy1of5w8mhbybwotujj24oq7skh5b38fea35-cd24-429d-86f7-aaef6f811a00) -4px -4px
    no-repeat;
  background-size: 128px 46px;
  margin-left: 19px;
  width: 120px;
}

.text-wrapper_13 {
  height: 30px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps0schzh0nr5uml77i7wv3cr5ed91z840hv24f2cd52-8c5f-438d-91d9-67f4d30b5dbd) -4px -4px
    no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_43 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 72px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 7px 0 0 15px;
}

.thumbnail_3 {
  width: 18px;
  height: 6px;
  margin: 14px 0 0 67px;
}

.text_44 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 14px;
}

.group_15 {
  height: 40px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pspkrrx6y2xynsgxkmf3ytg1wt4ldj5gd1ie54fa3d6-b464-4df3-a4cc-a238ae261827) -4px -4px
    no-repeat;
  background-size: 128px 46px;
  margin-left: 18px;
  width: 120px;
}

.text-wrapper_14 {
  height: 30px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pse5jdk1cmozk5koelj0w19c4d7va6h7oj3b4cb7d6d-018c-4bb8-99d3-e26fa7057fb2) -4px -4px
    no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_45 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 7px 0 0 16px;
}

.thumbnail_4 {
  width: 18px;
  height: 6px;
  margin: 14px 0 0 77px;
}

.text_46 {
  width: 80px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: SourceHanSansSC-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 8px 0 0 14px;
}

.group_16 {
  height: 40px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps4kbb79z649cg23dh5fekzb187owdojk7w2bd98073-bf3a-4321-9dc4-51b56e3f1a95) -4px -4px
    no-repeat;
  background-size: 128px 46px;
  margin-left: 16px;
  width: 120px;
}

.text-wrapper_15 {
  height: 30px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/ps8takumiak07tl3duu8difaiz6niho0lvraef4c056-b1b5-4931-bd3a-43742886503a) -4px -4px
    no-repeat;
  background-size: 109px 36px;
  width: 101px;
  margin: 5px 0 0 8px;
}

.text_47 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 7px 0 0 16px;
}

.thumbnail_5 {
  width: 18px;
  height: 6px;
}

.thumbnail_6 {
  width: 18px;
  height: 6px;
}

.image-wrapper_4 {
  width: 18px;
  height: 6px;
  margin-left: 430px;
}

.thumbnail_7 {
  width: 18px;
  height: 6px;
}

.image-wrapper_5 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 430px;
}

.thumbnail_8 {
  width: 18px;
  height: 6px;
}

.image-wrapper_6 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 430px;
}

.thumbnail_9 {
  width: 18px;
  height: 6px;
}

.image-wrapper_7 {
  width: 18px;
  height: 6px;
  margin: 4px 0 0 729px;
}

.thumbnail_10 {
  width: 18px;
  height: 6px;
}

.image-wrapper_8 {
  width: 18px;
  height: 6px;
  margin-left: 430px;
}

.thumbnail_11 {
  width: 18px;
  height: 6px;
}

.thumbnail_12 {
  width: 18px;
  height: 6px;
}

.image-wrapper_10 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 729px;
}

.thumbnail_13 {
  width: 18px;
  height: 6px;
}

.image-wrapper_11 {
  width: 18px;
  height: 6px;
  margin: 10px 0 0 729px;
}

.thumbnail_14 {
  width: 18px;
  height: 6px;
}

.image-wrapper_12 {
  width: 18px;
  height: 6px;
  margin: 31px 0 0 199px;
}

.thumbnail_15 {
  width: 18px;
  height: 6px;
}

.image-wrapper_13 {
  width: 18px;
  height: 6px;
  margin: 12px 0 0 199px;
}

.thumbnail_16 {
  width: 18px;
  height: 6px;
}

.image-wrapper_14 {
  width: 18px;
  height: 6px;
  margin: 12px 0 0 199px;
}

.thumbnail_17 {
  width: 18px;
  height: 6px;
}

.image-wrapper_15 {
  width: 18px;
  height: 6px;
  margin: 12px 0 167px 199px;
}

.thumbnail_18 {
  width: 18px;
  height: 6px;
}

.block_4 {
  width: 902px;
  height: 41px;
  margin: 23px 0 0 22px;
}

.image_9 {
  width: 24px;
  height: 15px;
  margin-top: 5px;
}

.group_17 {
  width: 123px;
  height: 41px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psxdnkbgwvi22gnzxc6z7wbqse4j5778acade0cdcf-dbf7-416e-a032-48834633ff62) -1px
    0px no-repeat;
  background-size: 125px 41px;
  margin-left: 442px;
}

.image-text_2 {
  width: 86px;
  height: 17px;
  margin: 12px 0 0 18px;
}

.thumbnail_19 {
  width: 17px;
  height: 11px;
  margin-top: 3px;
}

.group_18 {
  height: 40px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/psbvi4t94iefe9or9rrn7p70amzkpkwtc2faddca6-1e3a-4327-ba4c-b150426ccdad) -4px -4px
    no-repeat;
  background-size: 128px 46px;
  width: 120px;
  margin: 1px 0 0 29px;
}

.text-wrapper_16 {
  height: 36px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/pscnnv9m32qfkef1wyubtt930gewnesvzkd107ac0b-d12e-4469-af99-f4e7902c189c)
    100% no-repeat;
  background-size: 100% 100%;
  width: 109px;
  margin: 1px 0 0 4px;
}

.text_48 {
  text-shadow: 0px -4px 6px rgba(255, 255, 255, 0.56);
  width: 71px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(87, 246, 255, 1);
  font-size: 18px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 18px;
  margin: 10px 0 0 20px;
}

.block_5 {
  width: 902px;
  height: 252px;
  margin: 23px 0 0 23px;
}

.text-wrapper_17 {
  height: 251px;

  width: 447px;
}

.text_49 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 13px 0 0 11px;
}

.block_6 {
  width: 902px;
  height: 251px;
  margin: 7px 0 23px 23px;
}

.text-wrapper_18 {
  height: 251px;
  background: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/e2e64426f06143a6bb73a7b1566c14f7_mergeImage.png)
    100% no-repeat;
  background-size: 100% 100%;
  width: 447px;
}

.text_50 {
  width: 257px;
  height: 15px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  font-family: SourceHanSansSC-Regular;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 15px;
  margin: 8px 0 0 11px;
}

.image_11 {
  width: 447px;
  height: 251px;
}
body * {
  box-sizing: border-box;
  flex-shrink: 0;
}
body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
    Arial, PingFang SC-Light, Microsoft YaHei;
}
input {
  background-color: transparent;
  border: 0;
}
button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}
.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}
[class*="van-"]::after {
  border-bottom: 0;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}
</style>
